import apiSlice from "./apiSlice";
const keyIssueSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addKeyIssue: builder.mutation({
            query: (body) => ({
                url: `issues`,
                method: 'POST',
                body,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            invalidatesTags: ['GetAllIssueTag']
        }),
        editKeyIssue: builder.mutation({
            query: ({ id, body }) => ({
                url: `issues/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['GetAllIssueTag', 'SubmittedByIssueTag']
        }),
        deleteKeyIssue: builder.mutation({
            query: (id) => ({
                url: `issues/${id}`,
                method: 'DELETE',
            }),
        }),
        getPendingIssue: builder.query({
            query: (req) => ({
                url: `issues/pending`,
                params: req,
            }),
            providesTags: ["PendingIssueTag"],
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getSubmittedByMeIssue: builder.query({
            query: (req) => ({
                url: `issues/GetSubmittedIssues`,
                params: req,
            }),
            providesTags: ["SubmittedByIssueTag"],
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getKeyIssue: builder.query({
            query: (req) => ({
                url: `issues/${req}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        updateWorkFlow: builder.mutation({
            query: (body) => ({
                url: `issues/UpdateWorkflow`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ["PendingIssueTag", "SubmittedByIssueTag"]
        }),
        generateOtp: builder.query({
            query: (req) => ({
                url: `issues/GenrateOtp`,
                params: req
            }),
        }),
        verifyOtp: builder.mutation({
            query: (body) => ({
                url: `issues/ValidateOtp`,
                method: 'POST',
                body,
            }),
        }),
    }),
})

export const { useVerifyOtpMutation, useGenerateOtpQuery, useUpdateWorkFlowMutation, useGetKeyIssueQuery, useAddKeyIssueMutation, useEditKeyIssueMutation, useDeleteKeyIssueMutation, useGetPendingIssueQuery, useGetSubmittedByMeIssueQuery } = keyIssueSlice
